<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["change"],
  methods: {
    handleChange() {
      this.$emit("change", this.id);
    },
    handleClick() {
      this.$refs.radio?.click();
    },
  },
};
</script>

<template>
  <div class="s-card selectable-card" :class="{checked}" @click="handleClick">
    <div class="selectable-card__header">
      <slot name="header" />
      <input ref="radio" :id="id" :name="name" :checked="checked" :value="id"
        type="radio" @change="handleChange">
    </div>
    <slot></slot>
  </div>
</template>

<style scoped>
.selectable-card {
  display: flex;
  cursor: pointer;
  flex-direction: column;
  box-shadow: 0 0 0 2px rgba(34, 34, 34, 0.2);
}

.selectable-card:hover {
  box-shadow: 0 0 0px 2px rgba(34, 34, 34, 0.6);
}

.selectable-card.checked {
  box-shadow: 0 0 0 2px #0f93b8;
}

.selectable-card__header {
  gap: 0.5em;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.readonly input[type="radio"] {
  display: none;
}

.selectable-card__header input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;

  width: 1rem;
  height: 1rem;
  cursor: pointer;
  aspect-ratio: 1/1;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 0 0 1px #0f93b8;

  &:checked {
    background: #0f93b8;
  }
}
</style>